import { Component } from '@angular/core';
import { gql } from 'apollo-angular';
import { UserService } from '@services/user/user.service';
import { LogoutUser } from '@app/subscriptions/session.subscription';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private logoutUserSubscription: LogoutUser,
    public userService: UserService,
  ) {
    this.userService.getAidStationById();
    this.logoutUserSubscription
      .subscribe({
        idUser: this.userService.currentUser._id,
      })
      .subscribe((data) => {
        if (data) {
          window.location.reload();
        }
      });
  }
}
